import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import cssMixin from 'src/styles';
import DetailContents from './DetailContents';
import { ThemeType } from '@src/types/theme';
import { t_library } from '@src/types/tables';

export type DetailLayoutProps = {
	data: t_library;
	libraries: t_library[];
}

export default function DetailLayout(props: DetailLayoutProps)
{
	const [ isPurchase, setIspurchase ] = useState(false);
	const [ buyList, setBuyList ] = useState<any[]>([]);
	const [ listNum, setListNum ] = useState<number>(20);

	useEffect(() => {
		if (props.data && buyList[0])
			setIspurchase(buyList.some(e => e.LIBRARY_USE_ID === props.data.id))
	}, [props.data, buyList])

	return (
		<Wrapper>
			<DetailContents data={ props.data! } isPurchase={ isPurchase } libraries={ props.libraries } listNum={ listNum } />
		</Wrapper>
	);
}

const Wrapper = styled.div`
	${ cssMixin.container };
	width: 100%;
	display: flex;

	${({ theme }: { theme: ThemeType }) => theme.breakpoint.tablet`
		display: initial;
	`};
`;